module.exports = __webpack_public_path__ + "static/media/YM43_1.e092910e.jpg";